import {authRequest} from "../members";

export const homeCoursesAPI = {
    getRules: async ({memberId, adminId, password}) => {
        return new Promise((resolve, reject) => {
            return authRequest('/getHomeCoursesRules', {}, (res) => {
                if (res.data.success) {
                    resolve(res.data);
                } else {
                    reject(res.data);
                }
            })({memberId, adminId, password});
        });
    },
    setHomeCourse: ({memberId, adminId, password, courseId}, cb) => {
        return authRequest('/setMemberHomeCourse', {courseId}, cb)({memberId, adminId, password});
    },
}

